import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-book-open-fill text-2xl text-primary-500"></i>
            </span>
            {isHome ? (
              <h1 className="font-heading text-xl font-bold text-foreground-900">
                韩漫网
              </h1>
            ) : (
              <span className="font-heading text-xl font-bold text-foreground-900">
                韩漫网
              </span>
            )}
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-52 pl-9 pr-4 py-2 text-sm rounded-full bg-background-100 border border-background-200/70 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 text-foreground-800 placeholder-foreground-400 transition-all"
              />
              <span className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-sm text-foreground-400"></i>
              </span>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer text-foreground-700 hover:bg-background-100 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 shadow-lg animate-in slide-in-from-top-2 duration-200">
          <div className="px-4 py-3">
            <div className="relative mb-3">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-full pl-9 pr-4 py-2.5 text-sm rounded-full bg-background-100 border border-background-200/70 focus:outline-none focus:border-primary-300 text-foreground-800 placeholder-foreground-400"
              />
              <span className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-sm text-foreground-400"></i>
              </span>
            </div>
            <Link
              to="/"
              className="block px-4 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-background-100 cursor-pointer whitespace-nowrap"
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className="block px-4 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-background-100 cursor-pointer whitespace-nowrap"
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className="block px-4 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-background-100 cursor-pointer whitespace-nowrap"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}